<div class="phone-number-amount-input-container">
  <div class="amount-display">
    <span class="currency-symbol">{{ currencySymbol }}</span>
    <input
      type="tel"
      class="amount-input-large"
      [disabled]="disabled"
      [placeholder]="placeholder"
      aria-label="Monto a pagar"
      [value]="internalValue"
      (input)="onAmountInput($event)"
      (keydown)="onAmountKeydown($event)"
      #amountInput
    />
  </div>
</div>
